<!--  -->
<template>
  <div>error</div>
  <div><el-button @click="goBack()">返回登录</el-button></div>
</template>

<script>
export default {
  data() {
    return {
    };
  },

  components: {},


  methods: {
    async goBack() {
      this.$store.dispatch("user/signOut"); //通过调用Stroe中的user modules 声明的 signOut 来进行登出
      this.$router.push("/login");

    }
  },
  mounted() {
  }
}

</script>
<style lang='scss' scoped></style>